// extracted by mini-css-extract-plugin
module.exports = {"nav-link":"SideNav_nav-link__dfufm","is-active":"SideNav_is-active__EfORG","list":"SideNav_list__S2F2D"};